import React from 'react'

export default function LoadingOverlay() {
  return (
    <div className='overlay active'>
      <progress className='absolute middle center circle'></progress>
    </div>
  )
}
